<icc-list
    [items]="colors"
    [searchable]="true"
    [itemTemplate]="'itemColor'"
    (select)="selectMuntinColor($event)"
    [tabs]="colorGroups"
    [selected]="selectedId"
></icc-list>

